<template>
    <v-dialog v-model="modal" max-width="600px" >
        <v-card>
            <v-card-title class="headline lighten-2">
                <div>Editar Datos del Cliente</div>
                <v-spacer></v-spacer>
                <v-btn icon @click="close">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
                
            </v-card-title>
            <v-card-text class="p-2">
                <v-row>
                    <v-col cols="12" class="text-center">
                        <v-alert type="warning" outlined>
                            Los cambios realizados aquí solo afectarán a esta venta y no modificarán los datos del cliente en otras ventas.
                        </v-alert>
                    </v-col>
                </v-row>
                <v-row>

                    <v-form cols="12" @submit.prevent="save">
                        <v-row class="ml-2 mr-2">
                            <!-- Aquí irían los campos de edición de datos del cliente -->
                            <v-col cols="12">
                                <v-text-field 
                                    label="Nombre del Cliente" 
                                    v-model="localClienteData.nombres"
                                />
                            </v-col>
                            <v-col cols="12">
                                <v-text-field 
                                    label="Apellido del Cliente" 
                                    v-model="localClienteData.apellidos"
                                />
                            </v-col>
                            <v-col cols="12">
                                <v-text-field 
                                    label="Numero de documento" 
                                    v-model="localClienteData.numero_documento"
                                >
                                    <template #prepend>
                                        {{ localClienteData.tipo_documento }}
                                    </template>
                                </v-text-field>
                            </v-col>
                            <v-col cols="12">
                                <v-text-field 
                                    label="Celular" 
                                    v-model="localClienteData.celular"
                                />
                            </v-col>
    
                            <v-col cols="12" class="text-right">
                                <v-btn
                                    class="mr-2 text-center"
                                    color="error"
                                    outlined=""
                                    @click="close"
                                >
                                    <v-icon left="">mdi-backspace</v-icon> Cerrar
                                </v-btn>
                                <v-btn
                                    class="mr-2 text-center"
                                    color="success"
                                    type="submit"
                                >
                                    <v-icon left="">mdi-content-save</v-icon>
                                    Guardar
                                </v-btn>
                            </v-col>

                        </v-row>
                    </v-form>
                </v-row>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    props: {
        value: {
            type: Boolean,
            default: false
        },
        clienteData: {
            type: Object,
            default: () => ({
                nombres : '',
                apellidos : '',
                email: '',
                tipoDocumento: '',
                numeroDocumento: '',
                telefono: ''
            })
        }
    },
    data() {
        return {
            localClienteData: { ...this.clienteData}   
        }
    },
    computed: {
        modal: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit('input', val);
            }
        }
    },
    watch: {
        clienteData(newVal) {
            this.localClienteData = { ...newVal };
        }
    },
    emits: ['save', 'input', 'close'],
    methods: {
        save() {
            this.$emit('save', this.localClienteData);
        },
        close() {
            this.$emit('close');
        }

    },
}
</script>


<style scoped>
    
</style>